// Color theme for My Greatest Self
export const theme = {
  colors: {
    // Dark backgrounds
    bgDark: '#0a0e1a',
    bgMedium: '#111827',
    bgLight: '#1f2937',
    
    // Text colors
    textPrimary: '#f9fafb',
    textSecondary: '#e5e7eb',
    textMuted: '#9ca3af',
    
    // Brand accents (Teal/Blue/Green)
    teal: '#14b8a6',
    blue: '#0ea5e9',
    green: '#10b981',
    
    // Gradient
    gradient: 'linear-gradient(135deg, #14b8a6 0%, #0ea5e9 50%, #10b981 100%)',
  },
  
  fonts: {
    primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  }
};